import { render, staticRenderFns } from "./MermaidChart.vue?vue&type=template&id=de920d62&scoped=true"
import script from "./MermaidChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./MermaidChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MermaidChart.vue?vue&type=style&index=0&id=de920d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de920d62",
  null
  
)

export default component.exports